import { Component, Input } from "@angular/core";

import { BaseControlComponent } from "../../../../../../form-controls/components/base-control/base-control.component";
import { State, Section, Page } from "../../../../../../common/models/flow.dto";
import { ContextInteractionService } from "../../../../../../form-controls/services/context-interaction.service";


@Component({
    selector: "app-button-link-data-config",
    templateUrl: "./button-link-data-config.component.html",
    styleUrls: ["./button-link-data-config.component.scss"],
    standalone: false
})
export class ButtonLinkDataConfigComponent extends BaseControlComponent {
  
    @Input() selectedState: State;
    @Input() selectedSection: Section;

    pageSelectDisabled: boolean = false;

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }
  
    static componentName = "ButtonLinkDataConfigComponent";



    getPageTitle(page: Page, index: number): string {
        if (page.subtitle) return `${page.subtitle} - Page ${index}`;
        return `Page ${index}`;
    }

    getSectionName(section: Section, index: number): string {
        if (section.name)
            return `${section.name} - Section ${index}`;
        return `Section ${index}`;
    }

    getPagesForSection(): Page[] {
        if (this.componentData.config.section === null || this.componentData.config.section === undefined) return [];
        const sectionIndex = this.componentData.config.section;
        return this.selectedState.sections[sectionIndex].pages;
    }

    sectionChanged(): void {
        this.componentData.config.pageNumber = 0;
    }

    buttonTypeChanged(): void {
        this.pageSelectDisabled = (this.componentData.config.type !== "page");
    }
}
